import script from "./PortfolioPositionTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioPositionTable.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioPositionTable.vue?vue&type=style&index=0&id=14fb95e6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14fb95e6"]])

export default __exports__